export default __webpack_public_path__ + "static/media/thumbnail1.0a9779db.png";